import React, { useState } from 'react';
import { Button, Card } from '@ygtechnologies/rubus-ui';
import { faInfoCircle, faPlus } from '@fortawesome/pro-light-svg-icons';
import { ProductSourceCatalog, ProjectCatalogProduct } from '@/types';
import theme from './AvailableProductCard.module.scss';
import { CatalogProductThumbnails } from '@/seller/components/products/ProductThumbnails';
import { ProductMoreInfoModal } from '@/components/OptionConfigurator/ProductMoreInfoModal';
interface AvailableProductCardProps {
    product: ProjectCatalogProduct;
    onAdd(item: ProjectCatalogProduct): void;
}

export const AvailableProductCard: React.FC<AvailableProductCardProps> = ({ product, onAdd }) => {
    const [moreInfoIsOpen, setMoreInfoIsOpen] = useState(false);
    return (
        <Card className={theme.productCard}>
            <div className={theme.productInfo}>
                <CatalogProductThumbnails
                    size={70}
                    images={product.images || []}
                    catalog={ProductSourceCatalog.Project}
                    className={theme.productImage}
                />
                <div className={theme.productNameAndInfo}>
                    <div>{product.name}</div>
                    <Button icon={faInfoCircle} variant="tertiary" onClick={() => setMoreInfoIsOpen(true)} size="xs">
                        Product info
                    </Button>
                </div>
            </div>
            <Button icon={faPlus} variant="tertiary" onClick={(e) => onAdd(product)} size="sm" />
            <ProductMoreInfoModal
                isOpen={moreInfoIsOpen}
                toggleModal={() => setMoreInfoIsOpen(!moreInfoIsOpen)}
                product={product}
            />
        </Card>
    );
};
